import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: [],
  target: null,
  fetching: false,
  error: null,
};

export const creators = createActions({
  KPI_SUMMARY_REQUEST: (selectedYears) => ({
    selectedYears,
  }),
  KPI_SUCCESS: (payload) => payload,
  KPI_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const { summaryData } = payload;
  const targets = summaryData.filter(
    (item) => item.Name === 'Days Outstanding',
  );
  let target = null;
  if (targets.length > 0) {
    target = parseFloat(targets[0].Target);
  }

  return {
    ...state,
    fetching: false,
    summaryData,
    target,
  };
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    KPI_SUMMARY_REQUEST: summaryReducer,
    KPI_SUCCESS: successReducer,
    KPI_FAILURE: failureReducer,
  },
  initState,
);
